module.exports = __webpack_public_path__ + "img/zamknij.371e89c6.svg";